import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import TempleBuddhistRoundedIcon from "@mui/icons-material/TempleBuddhistRounded";
import TextureRoundedIcon from "@mui/icons-material/TextureRounded";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { simboloById } from "./designCalendarModel";

const ICON_BY_ID = {
  meeting: GroupsRoundedIcon,
  shopping: ShoppingBagOutlinedIcon,
  viaje: FlightTakeoffRoundedIcon,
  china: TempleBuddhistRoundedIcon,
  feria: TextureRoundedIcon,
  nota: StickyNote2OutlinedIcon,
  festival: AutoAwesomeRoundedIcon,
  inicio: PlayArrowRoundedIcon,
};

export function DesignCalendarSymbolIcon({ id, size = 18, sx, ...rest }) {
  const mark = simboloById(id);
  const Icon = ICON_BY_ID[mark.id] || StickyNote2OutlinedIcon;
  return (
    <Icon
      sx={{
        fontSize: size,
        color: mark.color,
        verticalAlign: "middle",
        flexShrink: 0,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function DesignCalendarSymbolStack({
  ids = [],
  size = 18,
  gap = 0.15,
  max = 4,
}) {
  const list = (ids || []).slice(0, max);
  if (!list.length) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: gap * 8,
        flexShrink: 0,
      }}
    >
      {list.map((id) => (
        <DesignCalendarSymbolIcon key={id} id={id} size={size} />
      ))}
    </span>
  );
}
